import { FacetFilterMenu } from '@/components/FacetFilterMenu'
import type { FacetGroup } from '@/components/FacetFilterMenu'
import { SHIPMENT_STATUS_LABELS, SHIPMENT_STATUS_VALUES } from '@/lib/shipment'
import { STATUS_GROUP_LABEL, STATUS_PARAM, countShipmentMenuFacets, toggleShipmentStatus } from '@/lib/shipmentFilters'
import type { ShipmentFacetFilters } from '@/lib/shipmentFilters'

interface ShipmentFilterMenuProps {
  filters: ShipmentFacetFilters
  onChange: (next: ShipmentFacetFilters) => void
}

export function ShipmentFilterMenu({ filters, onChange }: ShipmentFilterMenuProps): React.ReactElement {
  const groups: FacetGroup[] = [
    {
      key: STATUS_PARAM,
      label: STATUS_GROUP_LABEL,
      options: SHIPMENT_STATUS_VALUES.map((status) => ({
        key: status,
        label: SHIPMENT_STATUS_LABELS[status],
        isChecked: filters.statuses.includes(status),
        onToggle: () => onChange(toggleShipmentStatus(filters, status))
      }))
    }
  ]

  return (
    <FacetFilterMenu
      groups={groups}
      activeCount={countShipmentMenuFacets(filters)}
    />
  )
}
